import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuCaldas from '../components/MenuCaldas';
import Sponsors from '../components/Sponsors';
import ProgessTitle from '../components/ProgressTitle';
import '../assets/styles/containers/CheckRegisterInfo.sass';

const CheckRegisterInfo = (props) => {
  const [sponsors, setSponsors] = useState(null);
  const [info, setInfo] = useState([]);
  const [reference, setReference] = useState([]);
  const [signature, setSignature] = useState([]);
  const [message, setMessage] = useState('');

  const handleGoBack = () => {
    props.history.goBack();
  }

  const handlePay = () => {
    
  }

  const fetchUserInfo = (number) => {
    fetch(`${process.env.REACT_APP_URL}/validate-info/${number}`)
    .then(res => res.json())
    .then(
      (res) => {
        setInfo(res.info);
        setReference(res.referencia);
        setSignature(res.firma);
        setMessage(res.mensaje.content_es);
      },
      (error) => {
        console.error(error);
      }
    )
  }

  useEffect(() => {
    const session = sessionStorage.getItem('la-leyenda');
    const data = JSON.parse(session);
    fetchUserInfo(data.number);
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/sponsors/caldas`)
    .then(res => res.json())
    .then(
      (res) => {
        setSponsors(res.sponsors);
      },
      (error) => {
        console.error(error);
      }
    )
  }, []);

  const currency = (value) => {
    let thousands = "."
    let i = parseInt(value = Math.abs(Number(value) || 0)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    return (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
  }

  return (
    <Layout>
      <Banner id={13} city="caldas" thumb="/caldas/logo_caldas.png" />
      <MenuCaldas />
      <ProgessTitle step3="active" city="caldas" />
      <div className="row CheckRegisterInfo content-caldas">
        <div className="container">
          <div className="row">
            <div className="col-12">

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Nombre</dt>
                <dd class="col-sm-5">{info.name}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Apellido</dt>
                <dd class="col-sm-5">{info.surname}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Correo electrónico</dt>
                <dd class="col-sm-5">{info.email}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Teléfono</dt>
                <dd class="col-sm-5">{info.phone}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Inscripción y Merchandise</dt>
                <dd class="col-sm-5">
                  {info.products &&
                    info.products.map(item => <p>{item.quantity} - {item.item}</p>)
                  }
                </dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Precio</dt>
                <dd class="col-sm-5">$ {currency(info.value)}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Tipo de documento</dt>
                <dd class="col-sm-5">{info.type_id}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Documento No.</dt>
                <dd class="col-sm-5">{info.number}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Tipo de sangre</dt>
                <dd class="col-sm-5">{info.blood_group}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Proveedor de seguro médico / EPS</dt>
                <dd class="col-sm-5">{info.eps}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Nacionalidad</dt>
                <dd class="col-sm-5">{info.nacionality}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Sexo</dt>
                <dd class="col-sm-5">{info.sex}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Fecha de nacimiento</dt>
                <dd class="col-sm-5">{info.birthday_day} / {info.birthday_month} / {info.birthday_year}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Dirección</dt>
                <dd class="col-sm-5">{info.address}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Ciudad</dt>
                <dd class="col-sm-5">{info.city}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">País</dt>
                <dd class="col-sm-5">{info.country}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Acudiente en caso de emergencia</dt>
                <dd class="col-sm-5">{info.emergency_contact_name}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Teléfono acudiente con código de país</dt>
                <dd class="col-sm-5">{info.emergency_contact_number}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Talla de jersey (Especifico de género)</dt>
                <dd class="col-sm-5">{info.jersey_size}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Talla de camiseta (Especifico de género)</dt>
                <dd class="col-sm-5">{info.t_shirt_size}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Objetivo</dt>
                <dd class="col-sm-5">{info.race_aim}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Usuario Instagram</dt>
                <dd class="col-sm-5">{info.instagram}</dd>
              </dl>

              <dl class="row mb-0 justify-content-center">
                <dt class="col-sm-4">Condiciones médicas</dt>
                <dd class="col-sm-5">{info.medical_conditions}</dd>
              </dl>

              <div class="my-4"></div>

              {/* PayU form */}
              <div class="row mb-4">
                <div class="col text-right">

                  <form method="post" action={process.env.REACT_APP_PAYU_URL}>
                    <input name="merchantId" type="hidden" value={process.env.REACT_APP_PAYU_MERCHANT} />
                    <input name="accountId" type="hidden" value={process.env.REACT_APP_PAYU_ACCOUNT} />

                    <input name="description" type="hidden" value="Payment La Leyenda Series Caldas" />
                    <input name="referenceCode" type="hidden" value={reference} />

                    <input name="extra1" type="hidden" value={info.id} />
                    <input name="extra2" type="hidden" value={info.name} />
                    <input name="shippingCountry" type="hidden" value="CO" />
                    <input name="amount" type="hidden" value={info.value} />
                    <input name="tax" type="hidden" value="0" />
                    <input name="taxReturnBase" type="hidden" value="0" />
                    <input name="currency" type="hidden" value="COP" />
                    <input name="signature" type="hidden" value={signature} />
                    <input name="test" type="hidden" value="0" />
                    <input name="responseUrl" type="hidden" value="https://legendofeldorado.com/series-admin-temporal/respuesta" />
                    <input name="confirmationUrl" type="hidden" value="https://legendofeldorado.com/series-admin-temporal/confirmacion" />

                    <div className="row">
                      <div className="col-12">
                        <p>{ ReactHtmlParser(message) }</p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 CheckRegisterInfo-buttons">
                        <button type="button" class="btn btn-ll --caldas" onClick={() => handleGoBack()}>ATRAS</button>
                        <button type="submit" class="btn btn-ll --caldas" onClick={() => handlePay()}>PAGAR</button>
                      </div>
                    </div>
                  
                  </form>

                </div>
              </div>

              <div class="row mb-4">
                <div class="col text-center">
                  <img class="img-fluid" src="https://legendofeldorado.com/series-admin-temporal/img/logo_payu_pagos.jpg" alt="" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {sponsors &&
        <Sponsors
          customClass="--caldas"
          items={sponsors}
        />
      }
    </Layout>
  );
};

export default CheckRegisterInfo;
